import {observable, action, runInAction} from 'mobx'
import api from '../api'
import errorStore from './errorStore'

class ReactivateStore {
  @observable action = 'pending'

  @action.bound async reactivate(confirmationId) {
    if (this.action === 'pending') {
      try {
        await api.User.reactivateAccount(confirmationId)
        runInAction(() => {
          this.action = 'successful'
        })
      } catch (error) {
        runInAction(() => {
          this.action = 'unsuccessful'
        })
        errorStore.displayError(error.message)
      }
    }
  }
}

export default new ReactivateStore()



// WEBPACK FOOTER //
// ./src/stores/reactivateStore.js